import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import inventoryApi from "../api/inventoryApi";
import { ShimmerTable } from "react-shimmer-effects";
import Confirm from "./Confirm";
import csvDownload from "json-to-csv-export";
import Dropdown from "react-bootstrap/Dropdown";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import PubSub from "pubsub-js";
import InfoPill from "./InfoPill";
import { useStudentScoring } from "./StudentScoringHook";
import { isCenterAdmin } from "../utils/userScopeUtil";


const StudentList = () => {
  const navigate = useNavigate();
  const userRole = localStorage.getItem("userrole");
  const isSuperAdmin = userRole === "SUPER_ADMIN";
  const [body, setBody] = useState([]);
  const [csvData, setCSVData] = useState([]);
  const [regFormList, setRegFormList] = useState([]);
  const [servicearea, setservicearea] = useState([]);

  // Added By Jaseem (AMC Work) => Staff Wise Filtered Student CSV Report.
  // Date => 08-05-2026
  const [workerOptions, setWorkerOptions] = useState([]); 
  const [selectedWorkerId, setSelectedWorkerId] = useState("");
  const [selectedWorkerName, setSelectedWorkerName] = useState("");
  /**
   * RMKM new Implementation
   * @addedBy @ali-hussain
   * date : 12 September 2025
   * Make default status as Active
   */
  const [filterObj, setFilterObj] = useState({ status: "Active" });
  const [modalShow, setModalShow] = useState(false);
  const [studentid, setstudentid] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [currentAssessmentType, setcurrentAssessmentType] = useState();
  const [showModal, setShowModal] = useState(false);
  const [facpAssessment, setFacpAssessment] = useState([]);
  const [scoringName, setScoringName] = useState("");
  const [assessmentNumberList, setAssessmentNumberList] = useState([]);
  const [showAssessmentSelection, setShowAssessmentSelection] = useState(false);

  const { openScoringFromList } = useStudentScoring(navigate); // Added By Jaseem

  useEffect(() => {
    fetchServiceArea();
    if (isSuperAdmin) {
    // Added By Jaseem (AMC Work) => User Role Super Admin then fetch All Staff memeber.
    // Date => 08-05-2026
      fetchWorkers();
    }
    fetchStudents();
  }, []);

  useEffect(() => {
    doFilterData();
  }, [filterObj, body]);

  useEffect(() => {
    doFilterData();
  }, [body]);

  const fetchStudents = async (staffid = selectedWorkerId) => {
    try {
      setIsLoading(true);
      const query = isSuperAdmin && staffid ? { staffid } : undefined;
      const result = await inventoryApi.fetchStudents(query);
      if (result && result.length) {
        setBody(result);
        setRegFormList(result);

        // background CSV fetch
        inventoryApi
          .fetchStudentsCsvData(query)
          .then((csv) => setCSVData(Array.isArray(csv) ? csv : []))
          .catch((err) => {
            console.error("CSV fetch failed:", err);
            setCSVData([]);
          });
      } else {
        setBody([]);
        setRegFormList([]);
        setCSVData([]);
      }
    } catch (err) {
      console.error("Student fetch failed:", err);
      setBody([]);
      setRegFormList([]);
      setCSVData([]);
    }
    setIsLoading(false);
  };

  const fetchWorkers = async () => {
    try {
      const result = await inventoryApi.fetchStaffMember({ forcasehistory: true });
      setWorkerOptions(Array.isArray(result) ? result : []);
    } catch (err) {
      console.error("Worker fetch failed:", err);
      setWorkerOptions([]);
    }
  };

  const fetchServiceArea = async () => {
    try {
      const result = await inventoryApi.fetchServiceArea();
      if (result && result.length) {
        setservicearea(result);
      }
    } catch (err) {
      console.error("Service area fetch failed:", err);
      setservicearea([]);
    }
  };

  const onFilterSelection = (event) => {
    setFilterObj({ ...filterObj, [event.target.name]: event.target.value });
  };

  const onWorkerSelection = async (event) => {
    const staffid = event.target.value || "";
    setSelectedWorkerId(staffid);
    if (!staffid) {
      setSelectedWorkerName("");
      await fetchStudents("");
      return;
    }
    const selectedWorker = workerOptions.find((item) => item.id === staffid);
    setSelectedWorkerName(selectedWorker?.username || "");
    await fetchStudents(staffid);
  };

  const doFilterData = () => {
    if (!body) return;

    let tempData = [...body];

    if (filterObj.servicearea) {
      tempData = tempData.filter(
        (item) => item.servicearea === filterObj.servicearea
      );
    }

    if (filterObj.servicecategoryname) {
      tempData = tempData.filter(
        (item) => item.servicecategoryname === filterObj.servicecategoryname
      );
    }

    if (filterObj.status) {
      tempData = tempData.filter((item) => item.status === filterObj.status);
    }

    setRegFormList(tempData);
  };

  const handleDelete = (row) => {
    setModalShow(true);
    setstudentid(row);
  };

  const deleteStudent = async () => {
    try {
      const result = await inventoryApi.deleteStudent(studentid.id);
      if (result.success) {
        setModalShow(false);
        fetchStudents(); // refresh after delete
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Deleted",
          message: "Student record deleted successfully",
        });
      }
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };


  const header = [
    {
      title: "Reg No",
      prop: "regnumber",
      isFilterable: true,
      isSortable: true,
    },
    {
      title: "Student Name",
      prop: "name",
      isFilterable: true,
      isSortable: true,
      cell: (row) => (
        <Link to={`/students/${row.id}`} state={row}>
          {row.name}
        </Link>
      ),
    },
    {
      title: "Enrollment Age",
      prop: "childregistrationage",
      isFilterable: true,
    },
    { title: "Current age", prop: "child_age", isFilterable: true },
    { title: "Father Name", prop: "fathername", isFilterable: true },
    { title: "Phone", prop: "phone", isFilterable: true },
    // { title: "Gender", prop: "gender", isFilterable: true },
    // { title: "Address", prop: "address", isFilterable: true },
    {
      title: "Service Area",
      prop: "servicearea",
      isFilterable: true,
      isSortable: true,
    },
    { title: "Status", prop: "status", isFilterable: true },
    {
      title: "Assessment",
      prop: "partE",
      cell: (row) => (
        <Dropdown>
          <Dropdown.Toggle variant="primary" className="">
            Assessments
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {/* <Dropdown.Item onClick={() => openScoringFromList(row, "Student", "Physiotherapy")}>
              Physiotherapy
            </Dropdown.Item> */}
            <Dropdown.Item onClick={() => openScoringFromList(row, "DST")}>
              DST Scoring
            </Dropdown.Item>

            <Dropdown.Item onClick={() => openScoringFromList(row, "VSMS")}>
              VSMS Scoring
            </Dropdown.Item>

            <Dropdown.Item onClick={() => openScoringFromList(row, "GDT")}>
              GDT Scoring
            </Dropdown.Item>

            <Dropdown.Item onClick={() => openScoringFromList(row, "FACP")}>
              FACP Scoring
            </Dropdown.Item>

            <Dropdown.Item onClick={() => openScoringFromList(row, "PHYSIO")}>
              PHYSIO Scoring
            </Dropdown.Item>

            <Dropdown.Item onClick={() => openScoringFromList(row, "BEHAVE")}>
              VAPS Scoring
            </Dropdown.Item>
            <Dropdown.Item onClick={() => openScoringFromList(row, "GDT", "FACP Report")}>
              FACP Report
            </Dropdown.Item>
            <Dropdown.Item onClick={() => openScoringFromList(row, "Student", "Pdf Show")}>
              Student Case History
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ),
    },
    {
      title: "Action",
      prop: "id",
      cell: (row) => {
        // 1. localStorage se userid
        const userId = localStorage.getItem("userid") || "";

        // Delete allowed agar: ya to khud ka record hai, ya Super Admin hai
        const canDelete = row.createdbyid === userId || isSuperAdmin;

        return (
          <Button
            variant="danger"
            className="btn-sm mx-2"
            disabled={!canDelete}
            onClick={() => handleDelete(row)}
          >
            <i className="fa fa-trash"></i>
          </Button>
        );
      },
    },
  ];

  const createStudent = () => {
    navigate(`/students/e`);
  };

  const ReportDataCSV =
    csvData && csvData.length
      ? {
          data: csvData,
          filename: "Case History List Report",
          delimiter: ",",
          headers: Object.keys(csvData[0] || {}),
        }
      : null;

  return (
    <Row className="g-0">
      {modalShow && (
        <Confirm
          show={modalShow}
          onHide={() => setModalShow(false)}
          deleteStudent={deleteStudent}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="student"
        />
      )}

      <Col lg={5} className="mx-2">
        <Link className="nav-link">
          Home <i className="fa-solid fa-chevron-right"></i> Student
          Registration List
        </Link>
      </Col>

      <Col lg={12} className="p-lg-4">
        {!isLoading ? (
          <DatatableWrapper
            body={regFormList}
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 20,
                options: [5, 10, 15, 20],
              },
            }}
          >
            <Row className="mb-3 align-items-center g-2">
              {/* Search Filter */}
              <Col xs="auto">
                <Filter />
              </Col>

              {!isCenterAdmin() && (
                <>
              <Col xs="auto">
                <Form.Select
                  aria-label="Enter status"
                  name="servicearea"
                  onChange={onFilterSelection}
                  value={filterObj.servicearea}
                >
                  <option value="">--Service Category--</option>
                  <option value="School">School</option>
                  <option value="CBR">CBR</option>
                  <option value="Day Care">Day Care</option>
                </Form.Select>
              </Col>

              <Col xs="auto">
                <Form.Select
                  aria-label="Enter status"
                  name="servicecategoryname"
                  onChange={onFilterSelection}
                  value={filterObj.servicecategoryname}
                >
                  <option value="">--Service Area--</option>
                  {servicearea.map((value, index) => (
                    <option key={index} value={value.name}>
                      {value.name}
                    </option>
                  ))}
                </Form.Select>
              </Col>
                </>
              )}

              {/* Status */}
              <Col xs="auto">
                <Form.Select
                  aria-label="Enter status"
                  name="status"
                  onChange={onFilterSelection}
                  value={filterObj.status}
                >
                  <option value="">--All Students--</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                  <option value="Rejected">Rejected</option>
                  <option value="Dropout">Dropout</option>
                </Form.Select>
              </Col>

              {/* Filter by Worker (Super Admin only) */}
              {isSuperAdmin && (
                <Col xs="auto">
                  <Form.Select
                    aria-label="Filter by worker"
                    value={selectedWorkerId}
                    onChange={onWorkerSelection}
                  >
                    <option value="">--Filter by Worker--</option>
                    {workerOptions.map((worker) => (
                      <option key={worker.id} value={worker.id}>
                        {worker.username}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              )}

              {/* Count Pill + Buttons — right side */}
              <Col className="d-flex align-items-center justify-content-end gap-2">
                <InfoPill
                  left={selectedWorkerName ? selectedWorkerName : "Count"}
                  right={regFormList?.length}
                />

                {localStorage.getItem("userrole") === "SUPER_ADMIN" && ReportDataCSV && (
                  <Button
                    className="btn-sm"
                    variant="outline-success"
                    onClick={() => csvDownload(ReportDataCSV)}
                  >
                    <i className="fa-solid fa-file-csv fs-5"></i>
                  </Button>
                )}

                <Button
                  className="btn-sm"
                  variant="outline-primary"
                  onClick={() => createStudent(true)}
                >
                  New Registration
                </Button>
              </Col>
            </Row>
            <Table striped className="data-table">
              <TableHeader  className="center-header"/>
              <TableBody className="center-header" />
            </Table>
            <Pagination />
          </DatatableWrapper>
        ) : (
          <ShimmerTable row={10} col={8} />
        )}
      </Col>
    </Row>
  );
};

export default StudentList;

